module.exports = __webpack_public_path__ + "static/media/heartbeat.be9b38a8.svg";